export default "__VITE_ASSET__CjYcyqKD__"